import { getTokenFromLocalStorage } from './token';
import { jwtDecode as decode } from 'jwt-decode';

export enum LoginType {
    GOOGLE = 'google',
    FACEBOOK = 'facebook',
    LOCAL = 'local',
    SSO = 'sso',
    CRM_SSO = 'crm sso',
    WT_SSO = 'wt sso',
    KEEPALIVE = 'keepalive',
    RESET_PASSWORD = 'reset password',
}
interface TokenPayload {
    type: LoginType;
    user_id: string;
    token?: string;
}

const socialTypes = [LoginType.FACEBOOK, LoginType.GOOGLE];

export const isUserLoggedBySocial = (): boolean => {
    try {
        const token = getTokenFromLocalStorage();
        if (!token) return false;
        const parsedToken: TokenPayload = decode(token);
        return socialTypes.some((type) => parsedToken?.type?.toLowerCase() === type.toLowerCase());
    } catch (error) {
        return false;
    }
};
